// This icon file is generated automatically.
var PFolderOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.75 3.66h-5.6L5.3 1.91a.13.13 0 00-.09-.03H1.25a.5.5 0 00-.5.5v9.25c0 .27.22.5.5.5h11.5a.5.5 0 00.5-.5V4.16a.5.5 0 00-.5-.5zM12.12 11H1.88V3h2.94l1.87 1.79h5.43V11z", "fill-rule": "nonzero" } }] }, "name": "p-folder", "theme": "outlined" };
export default PFolderOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFolderOutlined.js
// module id = 3420
// module chunks = 0